import find from "lodash/fp/find";
import isNil from "lodash/fp/isNil";
class Controller {
  constructor($injector) {
    "ngInject";

    this.$injector = $injector;
    this.requested = null;
  }

  $onInit() {
    this.listRequires = this.field.requires;
    this.noListItemsMessage = `There are no data found. Add at least one and try again!`;
  }

  $doCheck() {
    const findFieldByName = (f) => f.name === this.listRequires;
    const requiredField = find(findFieldByName)(this.allFields);

    this.isListDisabled = requiredField ? !requiredField.value : false;
    this.capturedValue =
      requiredField && requiredField.value
        ? requiredField.value._id
        : undefined;

    if (this.isListDisabled || this.requested === this.capturedValue) {
      return;
    }

    const params = this.allFields.reduce((params, { name, value }) => {
      if (
        !isNil(this.extraParamsFields) &&
        this.extraParamsFields.includes(name) &&
        !isNil(value)
      ) {
        params[name] = value._id || value.id || value;
      }
      return params;
    }, {});
    this.requested = this.capturedValue;
    this.getListData(this.field, this.capturedValue, params);
  }

  getListData(field, required, params) {
    const resourceMethod = field.resourceMethod || "getAll";
    const resource = this.$injector.get(field.resource);
    const request = resource[resourceMethod].bind(resource);
    request({
      [field.requires]: required,
      ...field.resourceParams,
      ...params,
    }).$promise.then((response) => {
      const transformer = this.$injector.get(field.listTransformer);
      const transformerMethod = transformer[
        field.listTransformerMethod || "justify"
      ].bind(transformer);

      this.list = transformerMethod(response.hits, true);
      if (this.list.selected) field.value = this.list.selected;
    });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/asyncList/asyncList.controller.js